<!-- Selector de elementos con estilo de chip -->
<mat-chip-option
  id="selector-element-chip"
  [matMenuTriggerFor]="elementsMenu"
  (click)="openMenu($event)"
  [disabled]="isDisabled()"
  [selectable]="false"
  [ngClass]="{
    'selected-element': selectedElement(),
  }"
  class="selector-element-chip">
  <div class="chip-container">
    @if (selectedElement()) {
      <span>{{ selectedLabelPrefix() }}{{ chipLabel() }}</span>
    } @else {
      <span>{{ label() }}</span>
    }
    <span class="material-symbols-rounded dropdown-icon">{{
      isMenuOpen() ? 'expand_less' : 'expand_more'
    }}</span>
  </div>
</mat-chip-option>

<!-- Este es el Menú desplegable con las opciones -->
<mat-menu
  #elementsMenu="matMenu"
  class="elements-menu"
  (closed)="onMenuClosed()">
  <!-- @if (selectedElement() && unselectOption()) {
    <button mat-menu-item (click)="clearSelection()">
      <span class="textos-body-small">(Sin selección)</span>
    </button>
  } -->
  @for (element of elements(); track element.value) {
    <button
      mat-menu-item
      matTooltip="{{ getTooltipFor(element) || null }}"
      matTooltipPosition="right"
      (click)="onElementSelected(element)"
      matTooltipClass="chip-tooltip"
      [class.selected]="isSelected(element.value)">
      <span class="textos-body-medium">{{ element.viewValue }}</span>

      @if (isSelected(element.value)) {
        <span class="material-symbols-rounded check-icon">check</span>
      }
    </button>
  }
</mat-menu>
